import { EVENT_SUCCESS } from "manifest-bridge-core/src/events";
import { TransferData } from "../typings";

declare global {
  interface Window {
    Manifest: any;
  }
}

const sendSuccess = (data: TransferData, origin: string) => {
  window.parent.postMessage(
    {
      type: EVENT_SUCCESS,
      data,
    },
    origin,
  );
};

export default sendSuccess;
